import { NoDataException } from 'src/com/sixdee/crbtportal/utils/exceptions/nodataexistsexception';
import { DedicateFlashDto } from '../get/flashmessagedto';

export class DedicateFlashMessageBuilder
{
    constructor(private flashMessageList: any)
    {
        if(flashMessageList.flashDetails === undefined)
        {
            throw new NoDataException("FlashMessage data doesnt exists");
        }
    }

    buildAll(): DedicateFlashDto[]
    {
        return this.parseFlashMessageDetailsResponse();
    }
    
    private parseFlashMessageDetailsResponse(): DedicateFlashDto[]
    {
        let listOfFlashMessage: DedicateFlashDto[] = [];
        
       
        this.flashMessageList.flashDetails.forEach((messagesJson: any) =>
        {
            if(messagesJson.dedicationDetailsList !==null || messagesJson.dedicationDetailsList!== undefined)
            {
                messagesJson.dedicationDetailsList.forEach((dedidcateMessage: any) =>
                {
                    listOfFlashMessage.push(
                        new DedicateFlashDto(messagesJson.settingId, dedidcateMessage.name, 
                            dedidcateMessage.msisdn, messagesJson.flashMessage));
                });
            }

           
        });
        return listOfFlashMessage;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/flashmessage/dedicate/dedicateflashmessagebuilder.ts